import { db } from '../../utils/firebase';

export const getAllDomains = async () => {
  const querySnapshot = await db.collection("domains").get();

  const domains = [];
  querySnapshot.forEach(doc => {
    domains.push(doc.data());
  });

  return domains;
};